import styled from "styled-components";

import { TextField as DefaultTextField } from "@material-ui/core";

import { COLORS } from "constants/colorScheme";

export const TextField = styled(DefaultTextField)`
  && {
    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.RED};
    }

    && .MuiFormHelperText-root {
      top: 53px;
    }
  }
`;
